import { Bonus } from 'common/api/search/models/CanonicalSearchResultBrand';
import { SupportedType } from 'common/api/search/models/SupportedType';

export type ConstructorFacet = { name: string; values: SupportedType[] };

export type ConstructorReturnObject = {
    matched_terms: string[];
    data: {
        id: string;
        url: string;
        Bonus: Bonus[];
        group_ids: string[];
        image_url: string;
        IsFeatured: boolean;
        IsLocalProduct: boolean;
        IsOnBonus: boolean;
        MaxRebate: number;
        PopularityRank: number;
        ProductIds: number[];
        Rebate: number[];
        UrlSlug: string;
        facets: ConstructorFacet[];
        NewBannerExpiration?: string;

        // flipgive data
        AffiliateBonus?: number;
        AffiliateBonusEnd?: string;
        AffiliateBonusStart?: string;
        AffiliateExclusionText?: string;
        AffiliateOfferEarnText?: string;
        AffiliateOfferTerms?: string;
        AffiliateOfferUrl?: string;
        AffiliateRebate?: number;
        AffiliateVariablePricingText?: string;
        AffiliateBrandId?: number | string;
        CanDoubleDip: boolean;
        ContainsAffiliateOffer: boolean;
        ContainsVariableRebate: boolean;
        IsAffiliateOfferOnBonus: boolean;
        IsRaiseRightBrand: boolean;
        IsRaiseRightGiftCardOnBonusOrAffiliateOnBonus: boolean;
        AveragePurchaseDelayHours?: number;
    };
    value: string;
    is_slotted: boolean;
    labels: { [key: string]: any };
    result_id: string;
};

export enum EarnTypeConstructorFilter {
    GiftCards = 'Gift Cards',
    ShopOnline = 'Online',
}

export enum ConstructorGroups {
    // top-level group containing all groups
    All = 'all',

    // root group of all subgroups
    CustomerCategories = 'customerCategories',

    // root group for travel
    CustomerCategoriesTravel = 'customerCategories-travel',

    // Travel child group beneath customerCategories
    Travel = 'Travel',

    // featured groups
    AllFeatured = 'Filter-AllFeatured',
    IsFeatured = 'Filter-IsFeatured',
    IsAffiliateFeatured = 'Filter-IsAffiliateFeatured',
    TravelFeatured = 'Filter-TravelFeatured',

    // bonus groups
    TravelBonus = 'Filter-TravelOnBonus',
    IsOnBonus = 'Filter-IsOnBonus',
    AffiliateIsOnBonus = 'Filter-IsAffiliateOnBonus',
    IsOnBonusOrAffiliateOnBonus = 'Filter-IsOnBonusOrAffiliateOnBonus',

    IsSponsored = 'Filter-IsSponsored',
}

/** Constructor group ids (children of `customerCategories-travel`) for the Book Travel Hub categories, in display order. */
export enum TravelCategoryGroup {
    Flights = 'Flights',
    Cruises = 'Cruises',
    Lodging = 'Lodging',
    CampingAndRv = 'Camping & RV',
    Transportation = 'Transportation',
    Gas = 'Gas',
}
